import { connect } from 'react-redux';
import pipe from 'transmute/pipe';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import SharedDragDropContext from 'customer-data-ui-utilities/dnd/SharedDragDropContext';
import { getAuth } from '../../selectors/userSelectors/getAuth';
import AsyncFileManager from '../../code-splitting/components/AsyncFileManager';
export default pipe(connect(state => ({
  // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
  auth: getAuth(state)
})), SharedDragDropContext())(AsyncFileManager);